import Vue from 'vue';
import __CFG from '@/conf/config.json';

export default new Vue({
  data: function() {
    return {
      loanAmount: __CFG.default_amount || 1000,
      loanTenor: __CFG.default_tenor || 2,
      tenorSign: __CFG.tenor_sign || 'm',
      total: '',
      interest: '',
      commission: '',
      service: '',
      insurance: '',
      rrso: '',
      dailyInterest: '',
      nbpInterest: '',
      finishDate: ''
    };
  }
});



// WEBPACK FOOTER //
// ./src/stores/loanStore.js